import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useMainStore = defineStore('main', {
  state: () => ({
    processing: false,
    user: null,
    broker: null,
    pageTitle: null,
    allSidebarToolsShown: useLocalStorage('assurdeal/store/main/allSidebarToolsShown', false),
  }),

  getters: {
    shouldShowAllSidebarTools: (state) => state.allSidebarToolsShown,
  },

  actions: {
    /**
     * Set base data.
     *
     * @param {Object} user
     * @param {Object} broker
     */
    setBaseData({ user, broker }) {
      this.user = user;
      this.broker = broker;
    },

    /**
     * Starts processing.
     */
    startProcessing() {
      this.processing = true;
    },

    /**
     * Stops processing.
     */
    stopProcessing() {
      this.processing = false;
    },

    /**
     * Set page title.
     */
    setPageTitle(pageTitle: string) {
      this.pageTitle = pageTitle;
    },

    /**
     * Toggle all sidebar tools.
     */
    toggleShowAllSidebarTools() {
      this.allSidebarToolsShown = !this.allSidebarToolsShown;
    },
  },
});
